<template>
  <div class="printer">
    <box ref="box"></box>
    <el-card shadow="never" :style="style">
      <div class="searchBox">
        <div class="queryInfo">{{ $t('recentQuery') }} {{ updateTime }}</div>
        <el-button class="btn1" type="primary" :loading="saving" @click="_setPrinter()">{{ $t('save') }}</el-button>
        <el-button class="btn2" type="primary" :loading="searching" @click="_getPrinter()">{{ $t('queryButton') }}
        </el-button>
      </div>
      <el-form :model="form" label-width="120px" ref="form" :style="{height: bottomHeight}">
        <el-form-item :label="$t('printerSwitch')">
          <el-radio-group v-model="form.printSwitch">
            <el-radio :label="0">{{ $t('close') }}</el-radio>
            <el-radio :label="1">{{ $t('open') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('printSpeed')">
          <el-radio-group v-model="form.printMode">
            <el-radio :label="1">{{ $t('fast') }}</el-radio>
            <el-radio :label="2">{{ $t('slow') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('printType')">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
            {{ $t('all') }}
          </el-checkbox>
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group v-model="checkedPrint" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="printType in printTypes" :label="printType.name" :key="printType.id">{{ $t(printType.name) }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Box from "@/components/Box";
import {getPrinter, setPrinter} from "@/api/setting"
import {stampToDateTime} from "assets/utils";
import Status from "components/Status";
// const printOptions = [{name: 'fire'},'火警信息', '故障信息', '联动信息', '声光反馈信息','监管信息', '操作信息', '其他信息'];
const printOptions = [
  {name: 'fireInformation', id: 'fire', checked: false},
  {name: 'faultInformation', id: 'fault', checked: false},
  {name: 'linkageInformation', id: 'linkage', checked: false},
  {name: 'feedbackInformation', id: 'feedback', checked: false},
  {name: 'superviseInformation', id: 'supervise', checked: false},
  {name: 'operatorInformation', id: 'operator', checked: false},
  {name: 'otherInformation', id: 'other', checked: false}
];
export default {
  name: "printer",
  mixins: [Status],
  components: {
    Box
  },
  data() {
    return {
      form: {
        printSwitch: '',
        printMode: ''
      },
      printTypes: printOptions,
      isIndeterminate: false,
      checkAll: true,
      checkedPrint: [],// JSON.parse(JSON.stringify(printOptions)),
      bottomHeight: null,
      style: null,
      printType: '',
      updateTime: '',
      searching: false,
      saving: false
    }
  },
  mounted() {
    this.calcHeight()
  },
  computed: {
    controllInfo() {
      return this.$store.state.controlInfo
    },
    language() {
      return this.$store.state.language
    }
  },
  methods: {
    calcHeight() {
      setTimeout(() => {
        this.bottomHeight = this.$refs.box.$el.clientHeight + 'px'
        this.style = `height: calc(100vh - 100px - ${this.bottomHeight})`
      }, 20)
    },
    handleCheckAllChange(val) {
      if (val === true) {
        this.checkedPrint = []
        for (let i = 0; i < printOptions.length; i++) {
          this.checkedPrint.push(printOptions[i].name)
        }
      } else {
        this.checkedPrint = []
      }
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.printTypes.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.printTypes.length;
    },
    _setPrinter() {
      this.saving = true
      this.show()
      let searchParams = {
        controllerPsn: this.controllInfo.controllerPsn,
        controllerNo: 0,
        printMode: this.form.printMode,
        printSwitch: this.form.printSwitch
      }
      let printType = {}
      for (let i = 0; i < printOptions.length; i++) {
        if (this.checkedPrint.length > 0) {
          if (this.checkedPrint.indexOf(printOptions[i].name) >= 0) {
            printType[printOptions[i].id] = 1
          } else {
            printType[printOptions[i].id] = 0
          }
        } else {
          printType[printOptions[i].id] = 0
        }
      }
      searchParams.printType = printType
      setPrinter(searchParams).then((res) => {
        if (res.code === 1) {
          this.saving = false
          this.success(res.message ? res.message : '操作成功')
        }
      }).catch(() => {
        this.failed()
        this.saving = false
      })
    },
    _getPrinter() {
      this.checkedPrint = []
      this.searching = true
      this.show()
      let searchParams = {
        controllerPsn: this.controllInfo.controllerPsn,
        controllerNo: this.controllInfo.controllerNo
      }
      let _this = this
      getPrinter(searchParams).then((res) => {
        if (res.code === 1) {
          this.updateTime = stampToDateTime(res.data.updateTime)
          this.form.printSwitch = res.data.printSwitch
          this.form.printMode = res.data.printMode
          let printType = res.data.printType
          // let printType = {"feedback":1,"other":1,"supervise":1,"fire":1,"fault":1,"linkage":1,"operator":1}
          for (let key in printType) {
            if (printType[key] === 1) {
              printOptions.forEach((item) => {
                if (item.id === key) {
                  if (printType[key] === 1) {
                    _this.checkedPrint.push(item.name)
                  }
                }
              })
            }
          }
          if (_this.checkedPrint.length === printOptions.length) {
            this.isIndeterminate = false;
          }
          this.searching = false
          this.success(res.message ? res.message : '操作成功')
        }
      }).catch(() => {
        this.failed()
        this.searching = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.printer {
  .searchBox {
    padding: 0 0 10px 0;
    border-bottom: 1px solid #EBEEF5;

    .queryInfo {
      display: inline-block;
      padding: 0 0 10px 0;
      color: #B3BBC1;
      font-size: 12px;
    }

    .btn1, .btn2 {
      float: right;
      width: 90px;
    }

    .btn2 {
      margin-right: 20px;
    }
  }
}
</style>
